var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "enterPaymentModal",
        "dialog-class": "enter-payment-modal",
        centered: "",
        size: "md",
        title: _vm.$t("payment_modal_title"),
      },
      on: { hidden: _vm.hide },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "b-form",
        { staticClass: "enter-payment-form" },
        [
          _c(
            "info-row",
            {
              staticClass: "info-main-row",
              attrs: { title: "Amount", sizing: 3 },
            },
            [
              _c("currency-input", {
                attrs: {
                  disabled: !_vm.allowPartial,
                  name: _vm.$t("payment_modal_amount_label"),
                  amount: _vm.amount,
                  fieldState: _vm.fieldState.amount,
                },
                on: {
                  "update:amount": function ($event) {
                    _vm.amount = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.paymentMethod === _vm.systemPaymentMethods.OTHER
            ? _c(
                "info-row",
                {
                  staticClass: "info-main-row",
                  attrs: { title: "Platform", sizing: 3 },
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "input-group" },
                    [
                      _c("b-form-select", {
                        staticClass: "form-control",
                        attrs: { options: _vm.paymentPlatforms },
                        on: { input: _vm.updateDescription },
                        model: {
                          value: _vm.paymentPlatform,
                          callback: function ($$v) {
                            _vm.paymentPlatform = $$v
                          },
                          expression: "paymentPlatform",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod === _vm.systemPaymentMethods.OTHER
            ? _c(
                "info-row",
                {
                  staticClass: "info-main-row",
                  attrs: { title: "Transaction ID", sizing: 3 },
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "input-group" },
                    [
                      _c("b-form-input", {
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        on: { input: _vm.updateDescription },
                        model: {
                          value: _vm.transactionId,
                          callback: function ($$v) {
                            _vm.transactionId = $$v
                          },
                          expression: "transactionId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.paymentInfoIncomplete
            ? _c(
                "info-row",
                {
                  staticClass: "info-main-row",
                  attrs: { sizing: 3, title: "Description" },
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "input-group" },
                    [
                      _c("b-form-input", {
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          required: "",
                          title: "Description",
                          placeholder: "Special discount for a loyal customer",
                          readonly:
                            _vm.paymentMethod ===
                            _vm.systemPaymentMethods.OTHER,
                          state: _vm.fieldState.description,
                        },
                        model: {
                          value: _vm.description,
                          callback: function ($$v) {
                            _vm.description = $$v
                          },
                          expression: "description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer",
        },
        [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(_vm._s(_vm.warningText)),
          ]),
          _vm._v(" "),
          _vm.paymentMethod === _vm.systemPaymentMethods.STRIPE &&
          !!_vm.paymentType
            ? _c("payment-button", {
                attrs: {
                  chargeDescription: _vm.description,
                  payer: _vm.payer,
                  billTotal: parseFloat(_vm.amount),
                  chargeCallback: _vm.submitPayment,
                  disabled: _vm.loading,
                },
                on: { charge: _vm.submitCharge },
              })
            : _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    variant: "success",
                    disabled: _vm.paymentInfoIncomplete || _vm.loading,
                  },
                  on: { click: _vm.triggerPayment },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("payment_modal_button")) +
                      "\n    "
                  ),
                ]
              ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading ? _c("spinner-loader") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }